import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { url } from "./url.service";
import axiosAuth from "./axios.service";

const baseUrl = `${url}/admin/users`;

// GET ALL VENDORS
export const getAllVendors = async (queryParams?: any) => {
  return await axiosAuth.get(`${baseUrl}`, {
    params: {
      role: 'vendor',
      ...queryParams
    }
  });
};

export const useGetAllVendors = (enabled: boolean = true, queryParams?: any) => {
  return useQuery({
    queryKey: ["vendors", queryParams],
    queryFn: () => getAllVendors(queryParams).then((res) => res?.data?.data),
    enabled: enabled,
  });
};



// GET ALL deleted VENDORS
export const getAllDeletedVendors = async (queryParams?: any) => {
  return await axiosAuth.get(`${baseUrl}/deleted-users`, {
    params: {
      role: 'vendor',
      ...queryParams
    }
  });
};

export const useGetAllDeletedVendors = (enabled: boolean = true, queryParams?: any) => {
  return useQuery({
    queryKey: ["vendors-deleted", queryParams],
    queryFn: () => getAllDeletedVendors(queryParams).then((res) => res?.data?.data),
    enabled: enabled,
  });
};










// GET VENDOR BY ID
export const getVendorById = async (id: string | undefined) => {
  if (!id) throw new Error("No id provided");
  return await axiosAuth.get(`${baseUrl}/${id}`);
};

export const useGetVendorById = (id: string | undefined, enabled: boolean) => {
  return useQuery({
    queryKey: ["vendor", id],
    queryFn: () => getVendorById(id).then((res) => res?.data?.data),
    enabled: enabled,
  });
};

// CREATE NEW VENDOR
export const addVendor = async (data: any) => {
  return await axiosAuth.post(`${baseUrl}/`, data);
};

export const useAddVendor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addVendor,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendors"] });
    },
  });
};

// UPDATE A VENDOR
export const updateVendor = async ({ id, data }: { id: number | string; data: any }) => {
  if (!id) throw new Error("No id provided");
  return await axiosAuth.put(`${baseUrl}/${id}`, data);
};

export const useUpdateVendor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateVendor,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendors"] });
      queryClient.invalidateQueries({ queryKey: ["vendor"] });
    },
  });
};

// SUSPEND/UNSUSPEND A VENDOR

export const updateVendorStatus = async ({
  id,
  isActive,
}: {
  id: string;
  isActive: boolean;
}) => {
  if (!id) throw new Error("Vendor id required");
  return await axiosAuth.put(`${baseUrl}/issuspend/${id}`, {
    isSuspend: isActive,
  });
};

export const useUpdateVendorStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateVendorStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendors"] });
      queryClient.invalidateQueries({ queryKey: ["vendor"] });
    },
  });
};

// GET ALL VENDOR STOCKS

export const getStocksByVendorId = async (vendorId: any, queryParams?: any) => {
  if (!vendorId) throw new Error("No vendor id provided");
  return await axiosAuth.get(`${baseUrl}/vendor/${vendorId}/all-stocks`, {
    params: {
      ...queryParams
    }
  });
};

export const useGetStocksByVendorId = (vendorId: any, enabled: boolean, queryParams?: any) => {
  return useQuery({
    queryKey: ["stocks", vendorId, queryParams],
    queryFn: () => getStocksByVendorId(vendorId, queryParams).then((res) => res?.data?.data),
    enabled: enabled,
  });
};

// GET ALL VENDOR ORDERS

export const getOrdersByVendorId = async (vendorId: any, queryParams?: any) => {
  if (!vendorId) throw new Error("No vendor id provided");
  return await axiosAuth.get(`${baseUrl}/vendor/${vendorId}/all-orders`, {
    params: {
      ...queryParams
    }
  });
};

export const useGetOrdersByVendorId = (vendorId: any, enabled: boolean, queryParams?: any) => {
  return useQuery({
    queryKey: ["vendor-orders", vendorId, queryParams],
    queryFn: () => getOrdersByVendorId(vendorId, queryParams).then((res) => res?.data?.data),
    enabled: enabled,
  });
};

// GET ALL VENDOR Claims

export const getClaimByVendorId = async (vendorId: any, queryParams?: any) => {
  if (!vendorId) throw new Error("No vendor id provided");
  return await axiosAuth.get(`${baseUrl}/vendor/${vendorId}/all-claims`, {
    params: {
      ...queryParams
    }
  });
};

export const useGetClaimByVendorId = (vendorId: any, enabled: boolean, queryParams?: any) => {
  return useQuery({
    queryKey: ["vendor-claims", vendorId, queryParams],
    queryFn: () => getClaimByVendorId(vendorId, queryParams).then((res) => res?.data?.data),
    enabled: enabled,
  });
};



// GET ALL VENDOR SALES AGENTS

export const getAgentsByVendorId = async (vendorId: any, queryParams?: any) => {
  if (!vendorId) throw new Error("No vendor id provided");
  return await axiosAuth.get(`${baseUrl}/vendor/${vendorId}/sales-agents`, {
    params: {
      ...queryParams
    }
  });
};

export const useGetAgentsByVendorId = (vendorId: any, enabled: boolean, queryParams?: any) => {
  return useQuery({
    queryKey: ["sales-agents", vendorId, queryParams],
    queryFn: () => getAgentsByVendorId(vendorId, queryParams).then((res) => res?.data?.data),
    enabled: enabled,
  });
};



// delete vendor


export const deleteVendor = async ({
  id
}: {
  id: string;

}) => {
  if (!id) throw new Error("Vendor id required");
  return await axiosAuth.delete(`${baseUrl}/${id}`);
};

export const useDeleteVendor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteVendor,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendors"] });
      queryClient.invalidateQueries({ queryKey: ["vendor"] });
    },
  });
};